import { SpecialtyGroupExceptionHistoryTimeline } from "@app/projects/network-assessment/SpecialtyGroupExceptionHistoryTimeline";
import { FlyoutLink } from "@app/shared/Flyouts";
import { SpecialtyGroupException } from "@app/exceptions/interfaces";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import TooltipWrapper from "@app/shared/TooltipWrapper";
import { FC } from "react";

interface SpecialtyExceptionTimelineLinkProps {
  projectId?: number;
  regionSetSpecialtyGroupId?: number;
  specialtyGroupException?: SpecialtyGroupException;
  showHistory: boolean;
  visible: boolean;
}

const SpecialtyExceptionTimelineLink: FC<SpecialtyExceptionTimelineLinkProps> = (props: SpecialtyExceptionTimelineLinkProps) => {
  if (!props.visible) {
    return null;
  }

  const indicator = props.showHistory
    ? (
      <TooltipWrapper containerClassName="me-1" text="Show Exception Timeline Details" position="right">
        <FlyoutLink
          classNames="specialty-history-link text-dark p-0"
          content={{
            body: <SpecialtyGroupExceptionHistoryTimeline regionSetSpecialtyGroupId={props.regionSetSpecialtyGroupId} projectId={props.projectId} specialtyGroupException={props.specialtyGroupException} />,
            title: "Specialty Exception History",
          }}
          testId="specialty-group-exception-timeline-link__history-flyout"
        >
          <QesIcon iconName={QesIcons.ClockRewind} description="Opens exception history flyout" />
        </FlyoutLink>
      </TooltipWrapper>
    )
    : <span className="specialty-history-link" />;

  return (
    <>{indicator}&nbsp;</>
  );
}

export default SpecialtyExceptionTimelineLink;
